<template>
  <div>
    <table-view
      ref="tableList"
      tableCardTitle="LIST"
      :isTableLoading="isTableLoading"
      :searchModel="searchModel"
      :tableModel="tableModel"
      :pages="pages"
      :tableData="tableData"
      @pageChange="pageChange"
      @searchChange="handleSearchChange"
    >
      <template v-slot:bpmId="{ tableRow }">
        <a href="javascript:void(0)" @click="handleHrefInfoPage(tableRow.row)">
          {{ tableRow.row.bpmId }}
        </a>
      </template>
    </table-view>
  </div>
</template>

<script>
import { getBatchTable } from './api'

export default {
  name: 'batch-audit',
  data() {
    const searchModel = [
      { label: 'Trans#', type: 'input', key: 'bpmId' },
      {
        label: 'Status',
        type: 'select',
        key: 'status',
        selectList: [
          { id: 4, name: 'Approved' },
          { id: 5, name: 'Declined' },
        ],
      },
    ]
    const tableModel = [
      { slotName: 'bpmId', label: 'Trans#' },
      { prop: 'applier', label: 'Applicant' },
      { prop: 'approver', label: 'Assigned To' },
      { prop: 'statusStr', label: 'Status' },
    ]
    return {
      searchModel,
      tableModel,
      tableData: [],
      isTableLoading: true,
      pages: {},
    }
  },
  mounted() {
    this.initTable()
  },
  methods: {
    initTable() {
      const params = this.$refs.tableList.getSearchData()
      this._getTableList(params)
    },
    async _getTableList(params) {
      this.isTableLoading = true
      try {
        const { data, page } = await getBatchTable(params)
        console.error(data)
        this.tableData = data
        this.pages = page
      } catch (err) {
        console.error(err)
      }
      this.isTableLoading = false
    },
    handleSearchChange(params) {
      params.current = 1
      this._getTableList(params)
    },
    pageChange(curPage) {
      const queryForm = {}
      const params = Object.assign({}, queryForm, {
        current: curPage.current,
        size: 10,
        status: curPage.status,
      })
      this._getTableList(params)
    },
    handleHrefInfoPage(row) {
      let routeUrl = this.$router.resolve({
        name: 'batchAuditDetail',
        path: '/credit-management/credit-batch-request/audit-detail',
        query: {
          bpmId: row.bpmId,
          id: row.id,
          fileName: row.fileName,
          typeStr: row.typeStr,
          total: row.total,
        },
      })
      window.open(routeUrl.href, '_blank')
    },
  },
}
</script>

<style scoped lang="less"></style>
